<!-- NavCap (shown if item has no parent) -->
@if (depth === 0 && item.navCap && !item.parentSideMenuId) {
<div mat-subheader class="nav-caption">
  {{ langCode == 'en' ? item.nameEn : item.nameAr }}
</div>
}

<!-- Normal Menu Item -->
@if (!item.external || item.children?.length) {
<a mat-list-item
   (click)="onItemSelected(item)"
   [class]="'menu-list-item depth-' + depth + ' ' + (item.bgcolor || '')"
   [ngClass]="{
      'activeMenu': item.route ? router.isActive(item.route, true) : false,
      expanded: expanded,
      disabled: item.disabled,
      'pinned-item': isPinned
    }">
  <!-- Left guide line for tree look -->
  <span class="tree-line" *ngIf="depth > 0"></span>

  <!-- Icon -->
  <i-tabler class="routeIcon"
            [name]="item.iconName"
            matListItemIcon></i-tabler>

  <!-- Menu Text -->
  <span class="hide-menu">
    {{ langCode == 'en' ? item.nameEn : item.nameAr }}
  </span>

  <!-- Expand Arrow -->
  @if (item.children?.length) {
  <mat-icon class="arrow-icon" [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
    expand_more
  </mat-icon>
  }
  <!-- Chip -->
  @if (item.chipContent) {
  <span class="item-chip-container">
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill">
      {{ item.chipContent }}
    </span>
  </span>
  }
  <!-- Pin Button -->
  @if (shouldShowPinButton()) {
  <div class="pin-container" [class.pinned]="isPinned" (click)="togglePin($event)">
    <svg *ngIf="!isPinned" class="pin-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
    </svg>
    <svg *ngIf="isPinned" class="pin-svg pinned-svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
    </svg>
  </div>
  }
</a>
}

<!-- Children -->
@if (item.children?.length && expanded) {
  @for (child of item.children; track child.id) {
<app-nav-item [item]="child"
              [depth]="depth + 1"
              (click)="onSubItemSelected(child)"></app-nav-item>
  }
}
